import { render, staticRenderFns } from "./nxNavBar.vue?vue&type=template&id=08251370&scoped=true&"
import script from "./nxNavBar.vue?vue&type=script&lang=js&"
export * from "./nxNavBar.vue?vue&type=script&lang=js&"
import style0 from "./nxNavBar.vue?vue&type=style&index=0&id=08251370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08251370",
  null
  
)

export default component.exports